<template>
  <div class="container-fluid">
    <div class="card">
      <div class="card-header d-flex align-items-center">
        <h3 class="mb-0">รายการครบกำหนดชำระ</h3>
        <span class="ml-auto ml-2 mr-2">จังหวัด</span>
        <div class="mb-0 form-group mr-2">
          <select class="form-control" v-model="selectProvince" @change="reloadDT">
            <option value="null">ทุกจังหวัด</option>
            <option v-for="province in provinces" :key="province" :value="province">{{ province }}</option>
          </select>
        </div>
        <span class="mr-2">เดือน</span>
        <div class="mb-0 form-group">
          <select class="form-control" v-model="selectedMonth" @change="reloadDT">
            <option value="null">ทุกเดือน</option>
            <option v-for="month in months" :key="month.month" :value="month.month">{{ month.name }}</option>
          </select>
        </div>
        <span class="ml-2 mr-2">ปี</span>
        <div class="mb-0 form-group">
          <select class="form-control" v-model="selectedYear" @change="reloadDT">
            <option v-for="year in years" :key="year" :value="year">{{ year }}</option>
          </select>
        </div>
        <button class="btn btn-outline-primary ml-2" @click="paymentDueExport()"><i class="fa fa-print" aria-hidden="true"></i> ดาวน์โหลด Excel</button>
      </div>
      <div class="card-body table-responsive">
        <table class="table table-sm w-100 bg-white" id="datatable">
          <thead>
            <tr>
              <th>วันครบกำหนดชำระเงิน</th>
              <th>จำนวนเงิน</th>
              <th>เลขที่ใบส่งสินค้า</th>
              <th>วันที่ใบส่งสินค้า</th>
              <th>ชื่อลูกค้า</th>
              <th>จังหวัด</th>
              <th>เบอร์โทรศัพท์</th>
              <th>วันที่รับเงิน</th>
            </tr>
          </thead>
          <tbody></tbody>
          <tfoot>
            <tr>
              <td></td>
              <td></td>
              <td></td>
              <td></td>
              <td></td>
              <td></td>
              <td></td>
              <td></td>
            </tr>
          </tfoot>
        </table>
      </div>
    </div>
  </div> 
</template>

<script>
import VueSingleSelect from "vue-single-select";
export default {
  components: {
    VueSingleSelect
  },
  data() {
    return {
      provinces: [],
      months: [],
      years: [],
      msgSuccess: "",
      msgError: "",
      dataTable: null,
      selectedMonth: null,
      selectedYear: null,
      selectProvince: null
    };
  },
  created() {
    this.selectedMonth = moment().format('M');
    this.selectedYear = moment().format('Y');
  },
  async mounted() {
    let responseProvince = await axios.get("/data/provinces.json")
    this.provinces = responseProvince.data;

    let responseMonth = await axios.get("/data/months.json")
    this.months = responseMonth.data;

    this.years = Array.from({length: new Date().getFullYear() - 2018}, (value, index) => 2019 + index); // ปีย้อนหลัง 1 ปี และปีปัจจุบัน

    let parent = this;
    this.dataTable = $("#datatable").DataTable({
      dom: "tpr",
      pageLength: 50,
      processing: true,
      serverSide: true,
      ajax: {
        url: '/payments_due/datatable',
        data: function ( d ) {
          d.month = parent.selectedMonth;
          d.year = parent.selectedYear;
          d.province = parent.selectProvince;
        }
      },
      order: [[0, 'DESC']],
      columns: [
        { data: "payment_due_date", name: "payment_due_date" },
        { data: "net_total", name: "net_total" },
        { data: "do_ref", name: "do_ref" },
        { data: "do_date", name: "do_date" },
        { data: "customer.name", name: "customer.name" },
        { data: "customer.province", name: "customer.province" },
        { data: "customer.phone_number", name: "customer.phone_number" },
        { data: "received_date", name: "received_date" },
      ],
      initComplete: function() {
        //setup datatable when all data ready
        this.api()
          .columns([0, 1, 2, 3, 4, 5, 6, 7])
          .every(function(i) {
            let column = this;
            let input = null;

            if (i === 5) {
              input = $(document.createElement("select"));
              let province = null;
              input.append('<option value="">ทั้งหมด</option>');
              for (province of parent.provinces) {
                let option = document.createElement("option");
                $(option)
                  .attr("value", province)
                  .append(province);
                input.append(option);
              }
            } else input = $(document.createElement("input"));

            input
              .addClass("form-control form-control-sm")
              .css("width", "100%")
              .appendTo($(column.footer()).empty())
              .on("change", function() {
                column.search($(this).val(), false, false, true).draw();
              });
          });
        this.find("tfoot tr").appendTo(this.find("thead"));
      }
    });
  },
  methods: {
    reloadDT() {
      this.dataTable.ajax.reload(null, false); //reload dataTable
    },
    paymentDueExport() {
       window.location.href = "/payments_due/export?month=" + this.selectedMonth + "&year=" + this.selectedYear + "&province=" + this.selectProvince;
    }
  }
};
</script>